/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useState, useEffect } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Form } from '@unform/web';

import Button from '../../../../components/Button';
import Select from '../../../../components/Select';
import Input from '../../../../components/Input';
import ModalMotiva from '../ModalMotiva';

import { Container, Content } from '../../../../styles/components';
import { isValidCpf } from '../../../../utils/isValidCpf';
import { isValidCnpj } from '../../../../utils/isValidCnpj';
import {
  Main,
  AsideCard,
  BodyForm,
  DialogContent,
  Modal,
  FileDiv,
  MainForm,
  CompanyData,
} from './styles';

import check from '../../../../assets/ParaEmpresas/check.svg';

import FaqSection from '../../../../components/FaqSection';
import CoreService from '../../../../services/core';
import { useToast } from '../../../../hooks/toast';

import getValidationErrors from '../../../../utils/getValidationErrors';
import FileInputSpecial from '../FileInputSpecial';
import api from '../../../../services/api';
import { useLoader } from '../../../../hooks/loader';
import {
  BrasilApiCnpjResponse,
  useCnpjLookup,
} from '../../../../hooks/useCnpjLookup';
import ChipSelect from '../../../../components/ChipSelect';
import AutocompleteSelect from '../../../../components/AutocompleteSelect';
import { extractFieldErrors } from './ErrorMessage';

declare global {
  interface Window {
    lintrk: (action: string, options: Record<string, any>) => void;
  }
}

const ContrateAqui: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const services = { coreService: new CoreService() };
  const { addToast } = useToast();
  const [modalMotiva, setModalMotiva] = useState(true);
  const [categoriaSet, setCategoriaSet] = useState('');
  const [colaboradorSet, setColaboradorSet] = useState(0);
  const [cartaoSet, setCartaoSet] = useState(0);
  const [outros, setOutros] = useState();
  const { fetchCnpj, loading: loadingCnpj } = useCnpjLookup();
  const [autoBuscar, setAutoBuscar] = useState(false);
  const preencherComDadosCnpj = (data: BrasilApiCnpjResponse) => {
    const enderecoCompleto = [
      data?.logradouro,
      data?.numero,
      data?.bairro,
      data?.municipio,
      data?.uf,
      data?.cep ? `CEP: ${data.cep}` : null,
    ]
      .filter(Boolean)
      .join(', ');

    formRef.current?.setFieldValue('company_name', data?.razao_social || '');
    formRef.current?.setFieldValue('address_updated', enderecoCompleto);
  };
  const [digitacao, setDigitacao] = useState(0);

  const submittingRef = useRef(false);

  const { changeLoader, isActive } = useLoader();

  const modalidadeOptions = [
    { value: 'carga_a_bordo', label: 'Carga a bordo' },
    // { value: 'carga_nos_postos', label: 'Carga nos postos' },
  ];

  const FORM_FIELDS = [
    'modality',
    'company_name',
    'issqn',
    'address_updated',
    'legal_representative',
    'legal_representative_email',
    'aplicant_name',
    'email',
    'phone',
    'employee_number',
    'card_quantity',
    'company_document',
    'inscricao',
    'categoria',
    'rede_social',
    'otherinput',
    // arquivos
    'cpffile',
    'inscricaofile',
    'contratofile',
    'esocialfile',
    'managementagreement',
    'address_proof',
  ];

  const options = [
    {
      value: 'Google / Pesquisa na internet',
      label: 'Google / Pesquisa na internet',
    },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Anúncio em Rádio', label: 'Anúncio em Rádio' },
    { value: 'Anúncio em Site/Blog', label: 'Anúncio em Site/Blog' },
    { value: 'Anúncio nos ônibus', label: 'Anúncio nos ônibus' },
    { value: 'Indicação', label: 'Indicação' },
  ];

  const redeOptions = [
    ...options.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR')),
    { value: 'outro', label: 'Outro (qual?)' },
  ];

  const handleBuscarCnpj = useCallback(async () => {
    const cnpjAtual = formRef.current?.getFieldValue(
      'company_document',
    ) as string;

    // ⭐ mantém letras E números, remove só a máscara (pontos, barra, traço)
    const cnpjLimpo =
      cnpjAtual?.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() || '';
    console.log('CNPJ Limpo:', cnpjLimpo.length); // Adicione este log para depuração

    // 1. Validação local — 14 caracteres alfanuméricos
    if (cnpjLimpo.length !== 14) {
      addToast({
        type: 'error',
        title: 'CNPJ incompleto',
        description: 'Digite os 14 caracteres do CNPJ.',
      });
      return;
    }

    // 3. Chama a API
    const data = await fetchCnpj(cnpjLimpo);

    if (!data) {
      const temLetras = /[a-zA-Z]/.test(cnpjLimpo);

      if (temLetras) {
        addToast({
          type: 'info',
          title: 'CNPJ alfanumérico',
          description:
            'A busca automática pode não estar disponível para este formato. Continue preenchendo manualmente se necessário.',
        });
      } else {
        addToast({
          type: 'info',
          title: 'Não foi possível buscar o CNPJ',
          description:
            'Sem problemas! Continue preenchendo o formulário manualmente.',
        });
        return;
      }
    }

    preencherComDadosCnpj(data);
    if (data) {
      addToast({
        type: 'success',
        title: 'Dados encontrados!',
        description: `Razão social: ${data?.razao_social}`,
      });
    }
  }, [fetchCnpj, addToast, preencherComDadosCnpj]);

  const categoriaOptions = [
    { value: 'cpf', label: 'CPF' },
    { value: 'cnpj', label: 'CNPJ' },
  ];

  const issqnOptions = [
    { value: true, label: 'SIM' },
    { value: false, label: 'NÃO' },
  ];

  function showContactModal() {
    const opencontact = document.getElementById('contact');
    if (!opencontact) return;
    opencontact.style.display = 'block';
    setTimeout(() => {
      opencontact.style.display = 'none';
    }, 5000);
  }

  const schema = Yup.object().shape({
    modality: Yup.string().required('Modalidade é obrigatória'),
    company_name: Yup.string().required('Empresa é obrigatório'),
    issqn: Yup.string().required('ISSQN é obrigatório'),
    address_updated: Yup.string().required(
      'Endereço empresarial atualizado é obrigatório',
    ),
    legal_representative: Yup.string().required(
      'Nome do Representante Legal é obrigatório',
    ),
    legal_representative_email: Yup.string().required(
      'Email do Representante Legal é obrigatório',
    ),
    aplicant_name: Yup.string().required('Nome é obrigatório'),
    email: Yup.string()
      .required('E-mail é obrigatório')
      .email('Digite um email válido'),
    phone: Yup.string()
      .required('Telefone é obrigatório')
      .min(14, 'Telefone é obrigatório'),
    employee_number: Yup.string().required(
      'Número de Colaboradores é obrigatório',
    ),
    card_quantity: Yup.string().required('Número de Cartões é obrigatório'),
    company_document: Yup.string()
      .test(
        'cpf-cnpj-validation',
        value => (value.value.length <= 14 ? 'CPF Inválido' : 'CNPJ Inválido'),
        value => {
          if (value) {
            const isCpf = value.length <= 14;
            return isCpf ? isValidCpf(value) : isValidCnpj(value);
          }
          return true;
        },
      )
      .required('CPF ou CNPJ é obrigatório'),
    inscricaofile: Yup.string().required(
      'Arquivo da Inscrição Municipal é obrigatório',
    ),
    inscricao: Yup.string().required(
      'Número da Inscrição Municipal é obrigatório',
    ),
    contratofile: Yup.string(),
    esocialfile: Yup.string(),
    managementagreement: Yup.string(),
    cpffile: Yup.string().required('Este arquivo é obrigatorio.'),
    categoria: Yup.string().required('Categoria é obrigatória'),
    address_proof: Yup.string(),
    rede_social: Yup.string().required('Campo obrigatório'),
  });

  const handleChangeColaborador = (event: any) => {
    const newValue = parseInt(event?.target?.value || '', 10);
    setColaboradorSet(newValue);
  };
  const handleChangeCartao = (event: any) => {
    const newValue = parseInt(event?.target?.value || '', 10);
    setCartaoSet(newValue);
  };

  const handleChange = (event: any) => {
    setCategoriaSet(event?.value);
  };

  const handleSubmit = useCallback(
    async data => {
      if (submittingRef.current) return;

      submittingRef.current = true;
      changeLoader(true);
      const formData = new FormData();
      formData.append('aplicant_name', data?.aplicant_name);
      formData.append('company_name', data?.company_name);
      formData.append('company_document', data?.company_document);
      formData.append('issqn', data?.issqn);
      formData.append('address_updated', data?.address_updated);
      formData.append('legal_representative', data?.legal_representative);
      formData.append(
        'legal_representative_email',
        data?.legal_representative_email,
      );
      formData.append('card_quantity', data?.card_quantity);
      formData.append('email', data?.email);
      formData.append('modality', data?.modality);
      formData.append('phone', data?.phone);
      formData.append('employee_number', data?.employee_number);

      if (data?.rede_social === 'outro' && data?.otherinput) {
        formData.append('how_know', data.otherinput);
      } else {
        formData.append('how_know', data?.rede_social);
      }
      if (data?.cpffile) formData.append('document_file', data?.cpffile);
      if (data?.inscricaofile)
        formData.append('municipal_registration_file', data?.inscricaofile);
      if (data?.inscricao)
        formData.append('municipal_registration', data?.inscricao);
      if (data?.contratofile)
        formData.append('social_contract_file', data?.contratofile);
      if (data?.esocialfile) formData.append('cards_file', data?.esocialfile);
      if (data?.managementagreement)
        formData.append('management_agreement', data?.managementagreement);

      formData.append('is_cnpj', data?.categoria === 'cnpj' ? 'true' : 'false');

      if (data?.address_proof)
        formData.append('address_proof', data?.address_proof);

      try {
        formRef.current?.setErrors({});
        await schema.validate(data, { abortEarly: false });
        changeLoader(true);
        await api.post('/companies/empresas/contrate-aqui/', formData);

        changeLoader(false);
        submittingRef.current = false;
        addToast({
          type: 'success',
          title: `Informações Recebidas`,
          description: `Aguarde o contato dos nossos consultores.`,
        });

        showContactModal();
        formRef.current?.reset();
      } catch (err: any) {
        changeLoader(false);
        submittingRef.current = false;
        const { ...error } = err;

        // 1. Erros de validação do Yup (client-side)
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        // 2. Erro de resposta da API
        const apiData = error?.response?.data;

        if (!apiData) {
          addToast({
            type: 'error',
            title: 'Erro ao enviar',
            description: 'Verifique sua conexão e tente novamente.',
          });
          return;
        }

        // 3. Erros por campo (modality, issqn, legal_representative_email, ...)
        const fieldErrors = extractFieldErrors(apiData);

        if (Object.keys(fieldErrors).length > 0) {
          formRef.current?.setErrors(fieldErrors);

          // ⭐ pega a primeira mensagem pra mostrar no toast
          const primeiraMensagem = Object.values(fieldErrors)[0];

          addToast({
            type: 'error',
            title: 'Verifique os campos destacados',
            description: String(primeiraMensagem),
          });
          return;
        }

        // 4. Mensagem genérica da API (message / detail)
        const genericMessage = apiData.message || apiData.detail;

        if (genericMessage) {
          addToast({
            type: 'error',
            title: String(genericMessage),
            description: String(genericMessage),
          });
          return;
        }

        // 5. Fallback final — nenhum campo identificado nem mensagem
        addToast({
          type: 'error',
          title: 'Erro no envio',
          description:
            'Verifique se todos os dados estão preenchidos e anexados.',
        });
      }
    },
    [schema, services.coreService, addToast, changeLoader],
  );

  useEffect(() => {
    if (!autoBuscar) return;
    if (categoriaSet !== 'cnpj') return;

    const timer = setTimeout(() => {
      const cnpjAtual = formRef.current?.getFieldValue(
        'company_document',
      ) as string;
      if (cnpjAtual && cnpjAtual.replace(/\D/g, '').length === 14) {
        handleBuscarCnpj();
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [digitacao, autoBuscar, categoriaSet, handleBuscarCnpj]);

  useEffect(() => {}, [outros]);

  return (
    <>
      <Container>
        <Content style={{ maxWidth: '100%' }}>
          <Main>
            <AsideCard>
              <div className="header">
                <h2>Contrate aqui</h2>
                <span>
                  Envie os dados da empresa para que nossos consultores entrem
                  em contato com você.
                </span>
              </div>

              <MainForm className="main">
                <Form ref={formRef} onSubmit={handleSubmit}>
                  <BodyForm>
                    {/* ---- Linha: Categoria + Modalidade ---- */}
                    <div className="file-input-container">
                      <div className="input-container-text">
                        <p className="highlight-label">
                          Qual a sua categoria? CPF ou CNPJ
                        </p>
                        <ChipSelect
                          name="categoria"
                          options={categoriaOptions}
                          onChange={value => setCategoriaSet(String(value))}
                        />
                      </div>

                      <div className="input-container-text">
                        <p className="highlight-label">
                          Escolha a modalidade
                          <span className="asterisk"> *</span>
                        </p>
                        <ChipSelect
                          name="modality"
                          options={modalidadeOptions}
                          required
                        />
                      </div>
                    </div>

                    {/* ---- Bloco Dados da empresa ---- */}
                    <CompanyData className="dadosdaempresa">
                      <h3 className="Titulo_empresa">Dados da empresa</h3>

                      {/* CPF/CNPJ + Arquivo */}
                      {categoriaSet === 'cnpj' || categoriaSet === 'cpf' ? (
                        categoriaSet === 'cnpj' ? (
                          <div className="file-input-container">
                            <div className="input-container-text">
                              <p className="highlight-label">
                                CNPJ
                                <span className="asterisk"> *</span>
                              </p>

                              <div className="cnpj-input-search">
                                <div className="cnpj-input-wrapper">
                                  <Input
                                    cnpj
                                    name="company_document"
                                    placeholder="CNPJ"
                                    onChange={() => setDigitacao(d => d + 1)}
                                  />
                                </div>

                                {categoriaSet === 'cnpj' && (
                                  <button
                                    type="button"
                                    className="btn-buscar-cnpj"
                                    onClick={handleBuscarCnpj}
                                    disabled={loadingCnpj}
                                    title="Buscar dados na BrasilAPI"
                                  >
                                    {loadingCnpj ? '⏳' : '🔍'}
                                  </button>
                                )}
                              </div>
                            </div>

                            <div className="input-container-text">
                              <p
                                className="highlight-label"
                                style={{ textAlign: 'center' }}
                              >
                                Arquivo contendo o cartão CNPJ.
                              </p>
                              <FileDiv>
                                <FileInputSpecial
                                  name="cpffile"
                                  title="Selecione um Arquivo"
                                />
                              </FileDiv>
                            </div>
                          </div>
                        ) : (
                          <div className="file-input-container">
                            <div className="input-container-text">
                              <p className="highlight-label">
                                CPF
                                <span className="asterisk"> *</span>
                              </p>

                              <div className="cnpj-input-wrapper">
                                <Input
                                  cpf
                                  name="company_document"
                                  placeholder="CPF"
                                  onChange={() => setDigitacao(d => d + 1)}
                                />
                              </div>
                            </div>
                            <div className="input-container-text">
                              <p
                                className="highlight-label"
                                style={{ textAlign: 'center' }}
                              >
                                Arquivo contendo a identidade.
                              </p>
                              <FileDiv>
                                <FileInputSpecial
                                  name="cpffile"
                                  title="Selecione um Arquivo"
                                />
                              </FileDiv>
                            </div>
                          </div>
                        )
                      ) : (
                        <div className="input-container">
                          <p className="highlight-label">
                            CPF ou CNPJ
                            <span className="asterisk"> *</span>
                          </p>
                          <Input
                            cpforcnpj
                            disabled
                            name="company_document"
                            placeholder="CPF ou CNPJ"
                          />
                        </div>
                      )}

                      {/* Nome da empresa */}
                      <div className="input-container">
                        <p className="highlight-label">
                          Nome da empresa
                          <span className="asterisk"> *</span>
                        </p>
                        <Input
                          name="company_name"
                          placeholder="Nome da Empresa"
                        />
                      </div>

                      {/* Endereço */}
                      <div className="input-container">
                        <p className="highlight-label">
                          Endereço empresarial atualizado
                          <span className="asterisk"> *</span>
                        </p>
                        <Input
                          name="address_updated"
                          placeholder="Endereço empresarial atualizado"
                        />
                      </div>

                      {/* Representante Legal + E-mail */}
                      <div className="file-input-container">
                        <div className="input-container-text">
                          <p className="highlight-label">
                            Nome do Representante Legal (conforme
                            Contrato/Estatuto Social)
                            <span className="asterisk"> *</span>
                          </p>
                          <Input
                            name="legal_representative"
                            placeholder="Nome do Representante Legal"
                          />
                        </div>

                        <div className="input-container-text">
                          <p className="highlight-label">
                            E-mail do Representante Legal (para assinatura
                            digital)
                            <span className="asterisk"> *</span>
                          </p>
                          <Input
                            name="legal_representative_email"
                            placeholder="E-mail do Representante Legal"
                          />
                        </div>
                      </div>

                      {/* ISSQN */}
                      <div className="file-input-container">
                        <div className="input-container-text">
                          <p className="highlight-label">
                            Sua empresa é responsável pela retenção do ISSQN
                            (Imposto sobre Serviço de Qualquer Natureza)?
                            <span className="asterisk"> *</span>
                          </p>
                          <ChipSelect name="issqn" options={issqnOptions} />
                        </div>
                        <div className="input-container-text">
                          <div className="input-container-text">
                            <p className="highlight-label">
                              É uma agenciada? Se sim, envie o TERMO DE
                              GERENCIAMENTO.
                            </p>
                          </div>

                          <div className="field-body">
                            <FileDiv>
                              <FileInputSpecial
                                name="managementagreement"
                                title="Selecione um Arquivo"
                              />
                            </FileDiv>
                          </div>
                        </div>
                      </div>
                    </CompanyData>

                    {/* ---- Contato + E-mail ---- */}
                    <div className="file-input-container">
                      <div className="input-container-text">
                        <p className="highlight-label">
                          Nome do Contato
                          <span className="asterisk"> *</span>
                        </p>
                        <Input
                          name="aplicant_name"
                          placeholder="Nome do Contato"
                        />
                      </div>

                      <div className="input-container-text">
                        <p className="highlight-label">
                          E-mail do Contato
                          <span className="asterisk"> *</span>
                        </p>
                        <Input name="email" placeholder="E-mail" />
                      </div>
                    </div>

                    {/* ---- Telefones ---- */}
                    <div className="file-input-container">
                      <div className="input-container-text">
                        <p className="highlight-label">
                          Telefone (Principal)
                          <span className="asterisk"> *</span>
                        </p>
                        <Input
                          phone
                          name="phone"
                          placeholder="(xx) xxxxx-xxxx"
                        />
                      </div>

                      <div className="input-container-text">
                        <p className="highlight-label">
                          2° Telefone (Opcional)
                        </p>
                        <Input
                          phone
                          name="phone2"
                          placeholder="(xx) xxxxx-xxxx"
                        />
                      </div>
                    </div>

                    {/* ---- Colaboradores + Cartões ---- */}
                    <div className="file-input-container">
                      <div className="input-container-text">
                        <p className="highlight-label">
                          Número de Colaboradores
                          <span className="asterisk"> *</span>
                        </p>
                        <Input
                          type="number"
                          name="employee_number"
                          placeholder="Nº de Colaboradores"
                          onChange={handleChangeColaborador}
                        />
                      </div>

                      <div className="input-container-text">
                        <p className="highlight-label">
                          Quantidade de cartões desejados
                          <span className="asterisk"> *</span>
                        </p>
                        <Input
                          type="number"
                          name="card_quantity"
                          placeholder="Nº de Cartões desejados"
                          onChange={handleChangeCartao}
                        />
                      </div>
                    </div>
                    {/* ---- Campos exclusivos CPF ---- */}
                    {categoriaSet === 'cpf' && (
                      <div className="file-input-container">
                        <div className="input-container-text">
                          <p className="highlight-label">
                            ESOCIAL de um funcionário
                            <span className="asterisk"> *</span>
                          </p>
                          <FileDiv>
                            <FileInputSpecial
                              name="esocialfile"
                              title="Selecione um Arquivo"
                            />
                          </FileDiv>
                        </div>

                        <div className="input-container-text">
                          <p className="highlight-label">
                            Comprovante de Endereço
                            <span className="asterisk"> *</span>
                          </p>
                          <FileDiv>
                            <FileInputSpecial
                              name="address_proof"
                              title="Selecione um Arquivo"
                            />
                          </FileDiv>
                        </div>
                      </div>
                    )}

                    {/* ---- Campos exclusivos CNPJ ---- */}
                    {categoriaSet === 'cnpj' && (
                      <div className="file-input-container">
                        <div className="input-container-text">
                          <div className="label-wrap">
                            <p className="highlight-label">
                              Inscrição Municipal
                              <span className="asterisk"> *</span>
                            </p>
                          </div>

                          <div className="field-body">
                            <Input
                              numberinsc
                              type="number"
                              name="inscricao"
                              placeholder="Inscrição Municipal"
                            />
                            <FileDiv>
                              <FileInputSpecial
                                name="inscricaofile"
                                title="Selecione um Arquivo"
                              />
                            </FileDiv>
                          </div>
                        </div>

                        <div className="input-container-text">
                          <div className="label-wrap">
                            <p className="highlight-label">
                              Contrato Social / Estatuto / Ata de Nomeação /
                              Última Alteração Contratual
                              <span className="asterisk"> *</span>
                            </p>
                          </div>

                          <div className="field-body">
                            <FileDiv>
                              <FileInputSpecial
                                name="contratofile"
                                title="Selecione um Arquivo"
                              />
                            </FileDiv>
                          </div>
                        </div>

                        {colaboradorSet >= 21 && (
                          <div className="input-container-text">
                            <div className="label-wrap">
                              <p className="highlight-label">
                                ESOCIAL / CAGED / GEFIP
                                <span className="asterisk"> *</span>
                              </p>
                            </div>

                            <div className="field-body">
                              <FileDiv>
                                <FileInputSpecial
                                  name="esocialfile"
                                  title="Selecione um Arquivo"
                                />
                              </FileDiv>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* ---- Como conheceu ---- */}
                    <div className="input-container">
                      <AutocompleteSelect
                        name="rede_social"
                        label="Como você conheceu nossos serviços de VT?"
                        options={redeOptions}
                        placeholder="Como conheceu?"
                        required
                        onChange={(value: any) => {
                          setOutros(value);
                          if (value !== 'outro') {
                            formRef.current?.setFieldValue('otherinput', '');
                          }
                        }}
                      />
                    </div>

                    {outros && outros === 'outro' && (
                      <div className="input-container">
                        <p className="highlight-label">
                          Outros
                          <span className="asterisk"> *</span>
                        </p>
                        <Input name="otherinput" placeholder="Qual?" />
                      </div>
                    )}
                  </BodyForm>

                  <div className="footer">
                    <Button
                      type="submit"
                      color="orange"
                      padding="0"
                      className="orange-button"
                      rounded
                      disabled={isActive}
                    >
                      Enviar Dados
                    </Button>

                    <Modal id="contact">
                      <DialogContent>
                        <div className="container">
                          <div className="text">
                            <img
                              src={check}
                              alt="imagem confirmando as informações recebidas"
                              className="img"
                            />
                            <h1>Informações recebidas!</h1>
                            <p>Aguarde o contato dos nossos consultores.</p>
                          </div>
                        </div>
                      </DialogContent>
                    </Modal>
                  </div>
                </Form>
              </MainForm>
            </AsideCard>
          </Main>
        </Content>
      </Container>
    </>
  );
};

export default ContrateAqui;
